import { LibraryPageContext } from "@/pages/library_v2/components/filesView/context";

import { useContext } from "react";

import { FolderView } from "./folderItem";

export const FoldersListView: React.FC = () => {
  const { folders, selectedFolderName } = useContext(LibraryPageContext);

  return (
    <div className="my-[2px] ml-[17px] flex flex-col border-l border-[#F1EAEA] pl-[9px]">
      {folders.map((f) => (
        <FolderView
          key={f.name}
          folder={f}
          isActive={selectedFolderName === f.name}
        />
      ))}
    </div>
  );
};
